import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  contracts: [],
  isLoading: false,
  error: null
};

const contractsSlice = createSlice({
  name: 'contracts',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchContractsSuccess: (state, action) => {
      state.isLoading = false;
      state.contracts = action.payload;
    },

    createContractSuccess: (state, action) => {
      state.isLoading = false;
      state.contracts.push(action.payload);
    },

    updateContractSuccess: (state, action) => {
      state.isLoading = false;
      const updatedContract = action.payload;
      state.contracts = state.contracts.map(contract =>
        contract.id === updatedContract.id ? updatedContract : contract
      );
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchContractsSuccess,
  createContractSuccess,
  updateContractSuccess,
  deleteContractSuccess
} = contractsSlice.actions;

export default contractsSlice.reducer;
